<template>
    <div class="calendarView">
        <div class="headers">
            <b-button-toolbar key-nav aria-label="$t('aria_toolbar')">
                <b-button-group>
                    <b-button @click="changeView('month')">{{$t('nav.month')}}</b-button>
                    <b-button @click="changeView('week')">{{$t('nav.week')}}</b-button>
                    <b-button @click="changeView('day')">{{$t('nav.day')}}</b-button>
                </b-button-group>

                <b-button-group class="mx-1">
                    <b-button @click="navigate(-1)" :title="$t('nav.previous')">
                        <font-awesome-icon icon="chevron-left"></font-awesome-icon>
                    </b-button>
                    <b-button @click="toToday">{{$t('nav.today')}}</b-button>
                    <b-button @click="navigate(+1)" :title="$t('nav.next')">
                        <font-awesome-icon icon="chevron-right"></font-awesome-icon>
                    </b-button>
                </b-button-group>

                <b-button @click="createEvent">
                    <font-awesome-icon icon="plus"></font-awesome-icon> {{$t('nav.new')}}
                </b-button>
            </b-button-toolbar>
        </div>
        <div class="view">
            <calendar-month v-if="viewType==='month'" :events="events" :startDate="startDate"></calendar-month>
            <calendar-week v-if="viewType==='week'" :events="events" :startDate="startDate"></calendar-week>
            <calendar-day v-if="viewType==='day'" :events="events" :startDate="startDate"></calendar-day>
        </div>
        <calendar-event v-if="selectedEvent"
            :visible="isEditEventRoute"
            @hidden="closeEventDialog"
            :event="selectedEvent" @save="reloadCalendar" @deleteEvent="doDeleteEvent"></calendar-event>
        <!--<b-modal :visible="$route.name === 'calendarEvent'" @hidden="closeEventDialog">
            <calendar-event :event="selectedEvent"></calendar-event>
        </b-modal>-->
      <b-modal :visible="$route.name === 'calendarEditRecurEvent'" :title="$t('event.editRecur.title')"
          @hidden="closeRecurDialog">
        {{$t('event.editRecur.details')}}

        <template v-slot:modal-footer="{ cancel }">
          <b-button @click="cancel">{{$t('event.editRecur.cancel')}}</b-button>
          <b-button @click="editRecurOne">{{$t('event.editRecur.justOne')}}</b-button>
          <!--<b-button variant="primary" @click="editRecurFuture">{{$t('event.editRecur.future')}}</b-button>-->
          <b-button variant="primary" @click="editRecurSeries">{{$t('event.editRecur.allSeries')}}</b-button>

        </template>
      </b-modal>
    </div>
</template>

<script>
import axios from 'axios';
import CalendarMonth from '@/components/calendarMonth';
import CalendarWeek from '@/components/calendarWeek';
import CalendarDay from '@/components/calendarDay';
import { DateTime, Interval } from 'luxon';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import CalendarEvent from '@/components/calendarEvent';
import ICAL from 'ical.js';
import { v1 as uuidv1 } from 'uuid';
// ICAL docs - https://mozilla-comm.github.io/ical.js/api/index.html

export default {
  name: 'calendarView',
  components: { CalendarMonth, CalendarWeek, CalendarDay, FontAwesomeIcon, CalendarEvent },
  i18nOptions: { keyPrefix: 'calendars' },
  data: function() {
    return {
      loadedCalendars: {},
      events: [],
      loadedDates: {},
      newEvent: {}
    };
  },
  props: {
    viewDate: String,
    viewType: String,
    eventId: [String, Number],
    recurId: String
  },
  watch: {
    selectedCalendars(newVal, oldVal) {
      console.log('selected Calendars changed');
      const oldVal2 = Object.keys(this.loadedCalendars);
      const newVal2 = Object.keys(newVal);
      const newCalendars = newVal2.filter(c => !oldVal2.includes(c));
      const exCalendars = oldVal2.filter(c => !newVal2.includes(c));

      exCalendars.forEach(c => {
        console.log('remove calendar', c);
        c = parseInt(c, 10);
        this.$delete(this.loadedCalendars, c);
        this.removeCalendarEvents(c);
      });

      newCalendars.forEach(c => {
        console.log('add calendar', c);
        this.loadCalendar(c, true);
      });
    },
    startDate(newStart) {
      const newEnd = newStart.plus({ [this.viewType]: 1 });
      Object.keys(this.loadedCalendars).forEach(c => {
        let loadedDates = this.loadedDates[c];
        if ((!loadedDates) || (newStart < loadedDates.start) || (newEnd > loadedDates.end)) {
          this.loadCalendar(c, false);
        }
      });
    }
  },
  mounted() {
    Object.keys(this.selectedCalendars).forEach(c => {
      this.loadCalendar(c, true);
    });
  },
  methods: {
    loadCalendar(id, clearThisCalendar) {
      let start = this.startDate;
      let end = start.plus({ days: 60 });
      this.$set(this.loadedCalendars, id, true);
      let loadedDates = this.loadedDates[id];
      let needLoad = false;
      if ((!loadedDates) || (clearThisCalendar)) {
        console.log('data not loaded - need to load');
        loadedDates = { start, end };
        needLoad = true;
      } else {
        if (start < loadedDates.start) {
          console.log('start', start.toString());
          end = loadedDates.start;
          console.log('start', end.toString());

          const interval = Interval.fromDateTimes(start, end);
          if (interval.length('days') < 60) {
            start = end.minus({ days: 60 });
            console.log('start-60', start.toString());
          }
          loadedDates.start = start;
          needLoad = true;
        } else if (end > loadedDates.end) {
          start = loadedDates.end;
          const interval = Interval.fromDateTimes(start, end);
          if (interval.length('days') < 60) {
            end = start.plus({ days: 60 });
          }
          loadedDates.end = end;
          needLoad = true;
        }
      }
      if (needLoad) {
        console.log(loadedDates);
        this.$set(this.loadedDates, id, loadedDates);

        console.log('load calendar', id, start.toString(), end.toString());
        axios.get(`/rest/user/calendars/${id}`, { params: { start, end } })
          .then(d => {
            console.log('got calendar', id, d);
            if (clearThisCalendar) {
              this.removeCalendarEvents(id);
              this.$set(this.loadedDates, id, loadedDates);
            }
            this.events = this.events.concat(d.data.events.map(e => {
              e.startDateTime = DateTime.fromISO(e.start);
              e.endDateTime = DateTime.fromISO(e.end);
              return e;
            }));
          });
      }
    },
    reloadCalendar({ origCalId, event }) {
      if (event.calid !== origCalId) {
        this.removeCalendarEvent(event.id);
      }
      this.loadCalendar(event.calid, true);
    },
    doDeleteEvent({ event }) {
      console.log('doDeleteEvent');
      this.closeEventDialog();
      this.$nextTick(() => {
        console.log('remove event');
        this.removeCalendarEvent(event.id);
      });
    },
    removeCalendarEvent(id) {
      this.events = this.events.filter(e => {
        return e.id !== id;
      });
    },
    removeCalendarEvents(calId) {
      this.$delete(this.loadedDates, calId);
      this.events = this.events.filter(e => {
        return e.calid !== calId;
      });
    },
    changeView(e) {
      if (e === 'day') {
        this.$router.push(`/calendar/day/${this.viewDate}`);
      } else if (e === 'week') {
        this.$router.push(`/calendar/week/${this.startDate.startOf('week').toFormat('yyyyMMdd')}`);
      } else if (e === 'month') {
        this.$router.push(`/calendar/month/${this.startDate.startOf('month').toFormat('yyyyMMdd')}`);
      }
    },
    toToday() {
      const today = DateTime.local();
      if (this.viewType === 'day') {
        this.$router.push(`/calendar/day/${today.toFormat('yyyyMMdd')}`);
      } else if (this.viewType === 'week') {
        this.$router.push(`/calendar/week/${today.startOf('week').toFormat('yyyyMMdd')}`);
      } else if (this.viewType === 'month') {
        this.$router.push(`/calendar/month/${today.startOf('month').toFormat('yyyyMMdd')}`);
      }
    },
    navigate(offset) {
      const newDay = this.startDate.plus({ [this.viewType]: offset });
      this.$router.push({
        name: 'calendarView',
        params: Object.assign({}, this.$router.params, { viewDate: newDay.toFormat('yyyyMMdd') })
      });
    },
    closeEventDialog() {
      console.log('close event dialog');
      this.$router.push({ name: 'calendarView', params: this.$router.params });
    },
    createEvent() {
      this.newEvent = new ICAL.Component(['vcalendar', [], []]);
      this.newEvent.updatePropertyWithValue('prodid', '-//VPOP3 Webmail2');

      let vtimezone = ICAL.Component.fromString(this.$store.state.settings['servertimezoneical']);

      this.newEvent.addSubcomponent(vtimezone);

      let vevent = new ICAL.Component('vevent');
      let event = new ICAL.Event(vevent);

      event.summary = this.$t('newEventSummary');
      let startTime = DateTime.utc().startOf('minute');
      startTime = startTime.plus({ minutes: 5 - (startTime.minute % 5) });
      event.startDate = ICAL.Time.fromJSDate(startTime.toJSDate(), true);
      event.uid = uuidv1() + '@' + this.$store.state.settings.firstlocaldomain;
      event.duration = ICAL.Duration.fromSeconds(3600);

      // let recur = ICAL.Recur.fromString('FREQ=DAILY');
      // vevent.addPropertyWithValue('rrule', recur);

      this.newEvent.addSubcomponent(vevent);

      this.$router.push(
        { name: 'calendarEvent', params: Object.assign({}, this.$route.params, { eventId: 'new' }) });
    },
    closeRecurDialog() {
      if (this.$route.name === 'calendarEditRecurEvent') {
        this.$router.push({ name: 'calendarView', params: Object.assign({}, this.$route.params) });
      }
    },
    editRecurSeries() {
      this.$router.push({ name: 'calendarEvent', params: Object.assign({}, this.$route.params) });
    },
    editRecurOne() {
      this.$router.push({ name: 'calendarRecurEventSingle', params: Object.assign({}, this.$route.params) });
    },
    editRecurFuture() {
      this.$router.push({ name: 'calendarRecurEventFuture', params: Object.assign({}, this.$route.params) });
    }
  },
  computed: {
    startDate() {
      return DateTime.fromFormat(this.viewDate, 'yyyyMMdd');
    },
    selectedCalendars() {
      return this.$store.getters.selectedCalendars;
    },
    daySelect() {
      return null;
    },
    eventIdNumber() {
      if (typeof this.eventId === 'number') {
        return this.eventId;
      }
      return parseInt(this.eventId, 10);
    },
    selectedEvent() {
      if (!this.isEditEventRoute) {
        return null;
      }
      console.log('selectedEvent');
      if (this.eventId === 'new') {
        const thisUser = this.$store.state.username;
        let calid;
        const calendars = this.$store.getters.calendarDisplayList(this).filter(c => this.selectedCalendars[c.id]);
        console.log('calendars', calendars);
        if (calendars.length > 0) {
          calid = calendars[0].id;
          console.log('first selected calendar', calid);
        } else {
          calid = this.$store.state.calendars.find(c => {
            return (c.owner === thisUser) && (c.internalname === 'default');
          }).id;
        }
        return { raw: this.newEvent.toString(), newEvent: true, calid };
      }
      if (this.$route.name === 'calendarEvent') {
        return this.events.find(e => e.id === this.eventIdNumber);
      } else {
        return this.events.find(e => e.id === this.eventIdNumber && e.recurId === this.recurId);
      }
    },
    isEditEventRoute() {
      return this.$route.name === 'calendarEvent' ||
          this.$route.name === 'calendarRecurEventSingle' ||
          this.$route.name === 'calendarRecurEventFuture';
    }
  }
};
</script>

<style scoped lang="scss">

    .calendarView {
        width: 100%;
        height: 100%;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto minmax(0, 1fr);
        grid-template-areas: "headers" "view";
        .headers {
            grid-area: headers;
            h1 {
                font-size:1.2rem;
                font-weight: bold;
            }
        }
        .view {
            grid-area: view;
        }
    }

</style>
